<script lang="ts">
  import Input from '../Input.svelte';
  import EncodeButton from './EncodeButton.svelte';
  import Text from '../Text.svelte';

  export let value = '';
  export let label = '';
  export let description = '';
  export let dataTestid: string | undefined = undefined;
  export let showEncodeButton = false;
</script>

<div class="form-input-wrapper">
  <Text tagName="label" size="medium" for={label}>{label}:</Text>
  <div class="form-input">
    <Input id={label} placeholder={label} bind:value {dataTestid} {...$$restProps} />
    {#if showEncodeButton}
      <EncodeButton bind:url={value} />
    {/if}
  </div>
  {#if description}
  <Text tagName="span" size="small" color="tertiary">
    {description}
  </Text>
{/if}
</div>

<style lang="scss">
  @use '../../styles/spacing';

  .form-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: spacing.$xxs;
  }

  .form-input {
    display: flex;
    gap: spacing.$xxs;
  }
</style>
